import { Modal } from "@material-ui/core";
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";
import getStringsBasedLang from "../../strings/get_strings";
import { makeStyles } from "@material-ui/core/styles";
import { antiNameHandler } from "../../modules/anti_name_handler";
import moment from "moment-jalaali";
import { Button, Switch } from "antd";
import CustomPrimaryButton from "../../modules/custom_primary_button/custom_primary_button";
import { useNavigate } from "react-router-dom";
import { createData } from "../../api/http-service";
import UseErrorHandling from "../../hook/UseErrorHandling";
import LoginCustomInput from "../login/LoginCustomInput";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    paper: {
        position: "absolute",
        /*   width: 400, */
        backgroundColor: "#ffffff",
        border: 0,
        boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
        padding: theme.spacing(2, 4, 3),
        left: "50%",
        top: "50%",
        outline: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",
        [theme.breakpoints.down("xs")]: {
            width: 280,
            padding: 10,
        },
    },
    border: {
        border: "solid 1px #E0E0E0",
    },
    border_bottom: {
        borderBottom: "solid 1px #E0E0E0",
    },
}));

let promiseInfo = {};
const PasswordProtectModal = forwardRef((props, ref) => {
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [passValue, setPassValue] = useState('')
    const classes = useStyles();
    const lang = localStorage.getItem("lang");
    const handleErrorApi = UseErrorHandling();
    let token = localStorage.getItem("token");

    useImperativeHandle(ref, () => ({
        showProtectModal: async () => {
            return new Promise((resolve, reject) => {
                setShow(true);
                promiseInfo = {
                    resolve,
                    reject,
                };
            });
        },
    }));

    const countinueHandler = () => {
        if (passValue) {
            setIsLoading(true)
            createData(`scan/extract/${props.guid}`, { token: token, path: props.path, password: passValue })
                .then(protectResult => {
                    if (!protectResult?.success) {
                        handleErrorApi(protectResult);
                        return;
                    }
                    promiseInfo.resolve('ok');
                    setShow(false);
                })
                .catch((error) => {
                    setIsLoading(false);
                    if (error?.response) {
                        handleErrorApi(error?.response.data);
                    }
                });
        } else {
            toast.warning(getStringsBasedLang('confirmPass_validPass'))
        }
    };
    const rejectHandler = () => {
        setShow(false);
        promiseInfo.resolve("");
    };

    const handleClose = (event, reason) => {
        if (reason !== "backdropClick") {
            setShow(false);
        }
    };

    const enterKeyHadnler = (e) => {
        if (e.key === "Enter" && !isLoading) {

        }
        // confirmHandler()
    }

    const passOnchangeHandler = (e) => {
        const pass = e.target.value.trim()
        setPassValue(pass)
    }


    return (
        <React.Fragment>
            <Modal disableScrollLock={true} open={show} dis onClose={handleClose}>
                <div className={`${classes.paper} w-3/6 xs:w-5/6`}>
                    <div className="flex flex-col items-center my-5">
                        <span className="primary_text_color font-bold text-lg">
                            {getStringsBasedLang("register_confirmPasswrod")}
                        </span>
                    </div>
                    <LoginCustomInput
                        onChange={passOnchangeHandler}
                        isPassword={true}
                        icon="passowrd"
                        placeholder={getStringsBasedLang("confirmPass_validPass")}
                        enterPressed={(e) => enterKeyHadnler(e)}
                    />
                    <div className="flex items-center justify-center">
                        <CustomPrimaryButton
                            doClick={() => countinueHandler()}
                            text={getStringsBasedLang("general_countinue")}
                        />
                        <div>
                            <Button
                                onClick={() => rejectHandler()}
                                className={`rounded-3xl h-10 hover:-translate-y-1 ${lang === "en" ? "ml-5 w-32" : "mr-5 w-24"}`}
                                type=""
                            >
                                {getStringsBasedLang("cancel")}
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
});

export default PasswordProtectModal;
